<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core'
import { baseUrl } from '@/core/utils'
import Button from '@/core/components/base/Button.vue'
import LanguageView from '@/core/components/LanguageView.vue'
import type { OverviewMenuId } from '../../types'
import { SAMUDKOY } from '../../constants'
import { useMenuOverview, useMenuOverviewMock } from './MenuOverview'

const { currentMenu, doSelectMenu } = useMenuOverview()

const handleTap = useThrottleFn((menu: OverviewMenuId, event: PointerEvent) => {
  doSelectMenu(menu)
}, 250)
</script>

<template>
  <div class="menu-samudkoy">
    <!-- menu bullet -->
    <template v-for="menu in SAMUDKOY.MENUS">
      <Button :class="['bullet', menu]" :highlight="menu == currentMenu" @tap="handleTap(menu, $event)">
        <template #background><img src="/images/simakatra/bullet.png" /></template>
        <template #highlight><img class="blink" src="/images/simakatra/bullet-highlight.png" /></template>
      </Button>
    </template>

    <!-- menu title -->
    <template v-for="menu in SAMUDKOY.MENUS">
      <LanguageView lang="th">
        <Button :class="['title', menu]" @tap="handleTap(menu, $event)">
          <img :src="baseUrl(`/images/simakatra/th/${menu}.png`)" />
        </Button>
      </LanguageView>

      <LanguageView lang="en">
        <Button :class="['title', 'en', menu]" @tap="handleTap(menu, $event)">
          <img :src="baseUrl(`/images/simakatra/en/${menu}.png`)" />
        </Button>
      </LanguageView>
    </template>
  </div>
</template>

<style scoped>
/* ---------------------------- */
.blink {
  animation: blink 1.8s linear infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}
/* ---------------------------- */

.menu-samudkoy {
  position: absolute;
  left: 1390px;
  top: 578px;
  width: 500px;
}

.menu-samudkoy.disabled {
  pointer-events: none;
  cursor: auto;
}

/* prettier-ignore */
.bullet {
  position: absolute;
  left: 3px;
  &.menu1 { top: 15px; }
  &.menu2 { top: 123px; }
  &.menu3 { top: 198px; }
  &.menu4 { top: 273px; }
  cursor: pointer;
}

/* prettier-ignore */
.title {
  position: absolute;
  left: 44px;
  &.menu1 { top: 0px; }
  &.menu2 { top: 100px; }
  &.menu3 { top: 175px; }
  &.menu4 { top: 260px; }
}

/* prettier-ignore */
.title.en {
  &.menu1 { top: 14px; }
  &.menu2 { top: 115px; }
  &.menu3 { top: 194px; }
  &.menu4 { top: 267px; }
}
</style>
